import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Stack, useTokens } from '@barracuda-internal/bds-core';
import { fetchScans, fetchScan } from './scansReducer';
import { useScanFilters } from './hooks/useScanFilters';
import { useOpenScan } from './hooks/useOpenScan';
import ScanFilters from './ScanFilters';
import ScanList from './ScanList';
import ScanDetailDrawer from './ScanDetailDrawer';

export default function ScansPage() {
  const dispatch = useDispatch();
  const tokens = useTokens();
  const { filters } = useScanFilters();
  const { openScanId } = useOpenScan();

  const filtersKey = JSON.stringify(filters);
  React.useEffect(() => {
    dispatch(fetchScans({ filters }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filtersKey]);

  React.useEffect(() => {
    if (openScanId) dispatch(fetchScan(openScanId));
  }, [dispatch, openScanId]);

  return (
    <Box sx={{ padding: tokens.aliasesSpaceContainerSpacious }}>
      <Stack sx={{ gap: tokens.aliasesSpaceContainerDefault }}>
        <ScanFilters />
        <ScanList />
      </Stack>
      <ScanDetailDrawer />
    </Box>
  );
}
